import msToast from '../components/ms-toast/index.js';
import { Buffer } from 'buffer';
import i18n from '@/i18n/i18n';
import { MSEnum } from '@/common/enumeration';
// import { inspect } from 'util';
// import refType from '@/common/reftype';
import Vue from 'vue';
import { setTimeout } from 'timers';
import { Decimal } from 'decimal.js';
import apiConfig from '@/api/apiConfig';
// import httpClient from '@/api/httpClient';
import store from '@/store/store';
import router from '@/router';
import moment from 'moment';
import _ from 'lodash';

/**
 * Class chứa các function dùng chung cho hệ thống phía client
 * @author DNThang - 03.07.2019
 */
class CommonFunction {
	/**
	 * Chỉ gọi event cuối cùng khi người dùng click nhiều lần
	 * Thời gian delay mặc định là 0.25s
	 * @param {*} func
	 */
	onClickEvent = _.debounce(
		function(func) {
			if (func && typeof func == 'function') {
				func();
			}
		},
		(window.__env &&
			window.__env.siteConfig &&
			window.__env.siteConfig.onClickDebounceTime) ||
			500,
	);

	/**
	 * Lấy id của thiết bị
	 */
	getDeviceId() {
		const me = this;
		const keyDevice = 'DeviceId';

		//Lấy deviceid trong local storage
		let deviceId = localStorage.getItem(keyDevice);

		//Nếu chưa tồn tại thì tạo ra và lưu xuống local storage
		if (!deviceId) {
			deviceId = me.generateUUID();
			localStorage.setItem(keyDevice, deviceId);
		}

		return deviceId;
	}

	getGuidId() {
		const me = this;
		return me.generateUUID();
	}

	getNextMonthDate(date) {
		let month = date.getMonth();
		let temp = null;
		if (month < 11) {
			temp = date.setMonth(month + 1);
		} else {
			temp = date.setMonth(0);
			temp = date.setYear(date.getYear() + 1);
		}
		if (temp && !isNaN(temp)) {
			return new Date(temp);
		} else return temp;
	}

	/**
	 * Chuyển đổi ngày hiện tại sang kiểu Date
	 * @param {*} date
	 */
	parseStringToDate(date) {
		const me = this;

		try {
			if (date instanceof Date) {
				return date;
			} else {
				return moment(date).toDate();
			}
		} catch (ex) {
			me.errorLogging('Lỗi hàm chuyển đổi lỗi ngày hiện tại' + ex);
		}

		return new Date();
	}

	/**
	 * Xử lý lưu lại thông tin phục vụ tracking
	 * @param {String} msg Thông tin cần log
	 * @author DNThang - 03.07.2019
	 */
	infoLogging(msg, other) {
		if (process.env.NODE_ENV === 'development') {
			//Nếu có cả 2 giá trị
			if (msg && other) {
				console.debug(msg, other);
				return;
			}

			//Chỉ có message
			if (msg) {
				console.debug(msg);
				return;
			}

			//Chỉ có giá trị khác
			if (other) {
				console.debug(other);
				return;
			}
		}
	}

	/**
	 * Xử lý lưu lại thông tin phục vụ tracking
	 * @param {String} msg Thông tin cần log
	 * @author DNThang - 26.07.2019
	 */
	warnLogging(msg, other) {
		if (process.env.NODE_ENV === 'development') {
			//Nếu có cả 2 giá trị
			if (msg && other) {
				console.warn(msg, other);
				return;
			}

			//Chỉ có message
			if (msg) {
				console.warn(msg);
				return;
			}

			//Chỉ có giá trị khác
			if (other) {
				console.warn(other);
				return;
			}
		}
	}

	/**
	 * Xử lý lưu lại thông tin phục vụ tracking
	 * @param {string | Exception} msg Thông tin cần lưu
	 */
	errorLogging(msg, other) {
		if (process.env.NODE_ENV === 'development') {
			//Nếu có cả 2 giá trị
			if (msg && other) {
				console.error(msg, other);
				return;
			}

			//Chỉ có message
			if (msg) {
				console.error(msg);
				return;
			}

			//Chỉ có giá trị khác
			if (other) {
				console.error(other);
				return;
			}
		}
	}

	/**
	 * Hàm gọi func msToast
	 * @author NTMinh - 10.07.2019
	 * @modified DNThang - 13.12.2019: Bổ sung check tham số
	 */
	toast(parameters, hide = true) {
		if (parameters && parameters.text) {
			if (hide) {
				this.hideAllToast();
			}
			//Thay đổi toàn bộ kí tự đặc biệt `<`, `>` sang ký hiệu tương ứng để không bị ảnh hưởng việc hiển thị html
			// parameters.text = parameters.text.replace(/>/g, '&gt;').replace(/</g, '&lt;');
			msToast.msfunction(parameters);
		}
	}

	/**
	 * Kiểm tra array tồn tại phần tử item không
	 * @param {Array} collection
	 * @param {Object|String|Number} item
	 */
	contains(collection, item) {
		return collection.indexOf(item) !== -1;
	}

	/**
	 * Kiểm tra obj có phải Object không
	 * @param {Object} obj
	 */
	isObject(obj) {
		return (
			obj !== null &&
			obj &&
			typeof obj === 'object' &&
			!Array.isArray(obj)
		);
	}

	/**
	 * Kiểm tra Object có phải là Empty hay không?
	 */
	objectIsEmpty(obj) {
		for (let key in obj) {
			if (obj.hasOwnProperty(key)) {
				return false;
			}
		}
		return true;
	}
	/**
	 * Kiểm tra dữ liệu tồn tại dữ liệu khác
	 */

	objectHasDataEmpty(obj, otherList = []) {
		for (let key in obj) {
			if (otherList.includes(key)) {
				continue;
			} else if (obj.hasOwnProperty(key) && obj[key]) {
				return false;
			}
		}
		return true;
	}

	/**
	 * Kiểm tra function
	 * @param {Object} func
	 */
	isCallable(func) {
		return typeof func === 'function';
	}
	/**
	 * Lấy độ cao của màn hình
	 *
	 */
	getWindowHeight() {
		let windowHeight =
			window.innerHeight ||
			document.documentElement.clientHeight ||
			document.body.clientHeight;
		return windowHeight;
	}
	/**Kiểm tra độ phân giải của màn hình */
	checkSmallScreen() {
		if (window.innerHeight <= 768 || window.innerWidth <= 1366) {
			return true;
		} else {
			return false;
		}
	}
	getWidthByScreen(percent) {
		return (window.innerWidth / 100) * percent;
	}
	//#endregion Validation rules
	//Gộp url
	//CreatedBy: PDKIEN 24/07/2019
	//combineUrl("http://localhost","api","/v1")
	combineUrl() {
		if (arguments && arguments.length > 0) {
			let arr = [];
			for (let i = 0; i < arguments.length; i++) {
				let s = arguments[i],
					reg = new RegExp('^/*(.*?)/*$');
				arr.push(s.replace(reg, '$1'));
			}
			return arr.join('/');
		}
	}

	//Convert một object, array sang chuỗi Base64
	//CreatedBy: PDKIEN 30/7/2019
	convertToBase64(obj) {
		if (typeof obj != 'string') {
			obj = JSON.stringify(obj);
		}
		let buffer = Buffer.from(obj);
		let base64 = buffer.toString('base64');
		return base64;
	}

	/**
	 * Convert từ base64 sang object
	 * @param {Chuỗi đầu vào} base64String
	 * CreatedBy PDKIEN 09/10/2019
	 */
	convertFromBase64(base64String) {
		let buffer = Buffer.from(base64String, 'base64');
		let decode = buffer.toString('utf8');
		return decode;
	}

	/**
	 * Format string
	 * @param {string} inputString: chuỗi cần format
	 */
	stringFormat(inputString) {
		let formatted = inputString;
		for (let i = 1; i < arguments.length; i++) {
			let regexp = new RegExp('\\{' + i + '\\}', 'gi');
			formatted = formatted.replace(regexp, arguments[i]);
		}
		return formatted;
	}

	calculatorTotal(store, field) {
		let total = 0,
			data = store.getData();
		data.forEach(item => {
			total += Number(item[field]);
		});
		return total;
	}

	tableToExcel(table, name = 'name', fileName) {
		let uri = 'data:application/vnd.ms-excel;base64,',
			template =
				'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel;charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table><script type="text/javascript">document.getElementsByClassName("wiget")forEach(item=>()=>{item.remove()})</script></body></html>',
			base64 = function(s) {
				return window.btoa(unescape(encodeURIComponent(s)));
			},
			format = function(s, c) {
				return s.replace(/{(\w+)}/g, function(m, p) {
					return c[p];
				});
			};

		if (!table.nodeType) table = document.getElementById(table);
		let myTable = table.cloneNode(true);
		myTable.querySelectorAll('.wiget').forEach(item => {
			item.remove();
		});
		myTable.querySelectorAll('.check-multi').forEach(item => {
			item.remove();
		});
		myTable.querySelectorAll('.outLeft').forEach(item => {
			item.remove();
		});
		let ctx = {
			worksheet: name || 'Worksheet',
			table: myTable.innerHTML
		};

		let downloadLink = document.createElement('a');
		document.body.appendChild(downloadLink);
		// Create a link to the file
		downloadLink.href = uri + base64(format(template, ctx));
		// Setting the file name
		downloadLink.download = fileName + '.xls';

		//triggering the function
		downloadLink.click();
	}

	/**
	 * Xuất toàn bộ dữ liệu grid ra excel
	 * (Dành riêng cho các grid phân trang client)
	 * @param {MsGrid} grd Đối tượng grid cần xử lý xuất khẩu
	 * CreatedBy DNThang - 14.04.2020
	 * ModifiedBy DNThang - 15.04.2020: Sửa để đáp ứng cho grid cõ show một số column đặc thù: row_number, margin, ...
	 */
	exportAllDataToExcell(grd, name = 'name', fileName) {
		if (!grd) {
			return;
		}

		let store = grd.store;
		if (store && store.getCount() > 0) {
			let table = grd.$refs.table,
				tableExport;

			if (grd.pagination && grd.getTotalPages > 1) {
				//Nếu nhiều dữ liệu hơn 1 page thì phải xử lý gen all data
				let tHead = table.tHead,
					tBody = table.tBodies[0],
					rows = tBody.rows;
				if (rows.length > 0) {
					let row = rows[0],
						columnx = grd.columnx,
						i = 0,
						j = 0;

					tableExport = document.createElement('table');
					tableExport.tHead = tHead.cloneNode(true);

					let bodyTemp = tableExport.createTBody(),
						idxCellDataStart = 0,
						idxCellRowNum = -1;

					//Lấy ra index cell đầu tiên của grid tương ứng với column
					for (j = 0; j < row.cells.length; j++) {
						let cellTemp = row.cells[j];

						if (cellTemp.classList.contains('ms-table--td')) {
							if (
								cellTemp.classList.contains(
									'ms-grid-row-number'
								)
							) {
								if (idxCellRowNum === -1) {
									idxCellRowNum = j;
								}
							} else {
								idxCellDataStart = j;
								break;
							}
						}
					}

					for (i = 0; i < store.getCount(); i++) {
						let eRow = row.cloneNode(true),
							cells = eRow.cells,
							dataItem = store.getData()[i];

						if (idxCellRowNum > -1) {
							cells[idxCellRowNum].innerText = i + 1;
						}

						for (j = 0; j < columnx.length; j++) {
							let cell = cells[j + idxCellDataStart],
								col = columnx[j],
								value = dataItem[col.dataField],
								formatType = col.dataFormat,
								forceFormat = false;

							if (forceFormat || col.enumName) {
								value = grd.$options.filters.formatData(value, {
									type: formatType,
									enumName: col.enumName
								});
							}

							cell.innerText = value;
						}

						bodyTemp.appendChild(eRow);
					}
				}
			} else {
				tableExport = table;
			}

			if (tableExport) {
				this.tableToExcel(tableExport, name, fileName);
			}
		}
	}

	/**
	 *  Tạo uuid
	 *  Create by: pvduong1 - 30/08/2019
	 */
	generateUUID() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
			let d = new Date().getTime();
			d += performance.now();
			let r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
		});
	}
	generateUUIDFormat(format) {
		return format.replace(/[xy]/g, c => {
			let d = new Date().getTime();
			d += performance.now();
			let r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
		});
	}
	generateEmptyUUID() {
		return '00000000-0000-0000-0000-000000000000';
	}

	/**
	 * Chuyển đổi ngày tháng truyền vào sang kiểu TimeStampWithoutTimeZone
	 * Created by: NVLAM 17/09/2019
	 */
	convertToTimeStampWithoutTimeZone(dateTime) {
		let year = dateTime.getUTCFullYear(),
			month = dateTime.getUTCMonth(),
			date = dateTime.getUTCDate(),
			hours = dateTime.getUTCHours(),
			minutes = dateTime.getUTCMinutes(),
			seconds = dateTime.getUTCSeconds(),
			miliseconds = dateTime.getUTCMilliseconds();
		return (
			year +
			'-' +
			month +
			'-' +
			date +
			' ' +
			hours +
			':' +
			minutes +
			':' +
			seconds +
			'.' +
			miliseconds
		);
	}

	/**
	 * Check column name có phải là column dạng số không?
	 * (Dựa vào naming)
	 * @param {String} colName Tên cột cần check
	 * DNThang - 21.10.2019
	 */
	isNumberColumn(colName) {
		if (
			colName.contains('price') ||
			colName.contains('amount') ||
			colName.contains('quantity') ||
			colName.contains('rate') ||
			colName.contains('minimum_stock')
		) {
			return true;
		}
		return false;
	}

	/**
	 * Lấy ra form root của control hiện tại
	 * @return {VueInstance/Element}
	 */
	getOwnerForm(control, isShowPopup = true) {
		let me = this,
			ret = control;
		if (control) {
			if (
				control.$el &&
				control.$el.getVueInstance &&
				control.$el.getVueInstance().isMsPopup
			) {
				ret = control.$el.getVueInstance();
				return ret;
			} else {
				let parent = control.$parent || control.$msOwner;
				if (
					parent === undefined ||
					(parent.$vnode &&
						parent.$vnode.tag &&
						parent.$vnode.tag.endsWith('-MsPopup')) ||
					(parent && parent.$el && parent.$el.id === 'app')
				) {
					ret = control;
					return ret;
				} else {
					ret = me.getOwnerForm(parent);
				}
			}
		}

		return ret;
	}

	/**
	 * focus control nhập liệu lỗi đầu tiên
	 * @param {*} scope : container chứa các control sẽ kiểm tra
	 */
	focusFirstControlError(scope) {
		let el = scope.querySelector('.ms-input-validate-error');
		if (el != null) {
			el.focus();
			el.select();
		}
	}

	/**
	 * Tìm ra control Input đầu tiên theo scope truyền vào và cho phép sửa
	 * @param {Element} scope Parent cần tìm input
	 * @author DNThang - 31.10.2019
	 */
	findFirstControlInput(scope) {
		if (scope && scope.querySelector) {
			let input = scope.querySelector(
				'input:not([type=button]):not([type=radio]):not([type=checkbox]):not([readonly]):not([disabled]),textarea:not([readonly]):not([disabled])'
			);
			return input;
		}
		return;
	}

	/**
	 * Tự động focus vào control nhập liệu đầu tiên theo scope truyền vào
	 * @param {Element} scope Phạm vi cần xử lý focus
	 * @author DNThang - 31.10.2019
	 */
	focusFirstControlInput(scope) {
		const me = this;
		let input = me.findFirstControlInput(scope);
		if (input) {
			input.focus();

			if (typeof input.select === 'function') {
				input.select();
			}
		}
	}

	/**
	 * Tự động focus vào control nhập liệu đầu tiên theo scope truyền vào
	 * @param {Element} scope Phạm vi cần xử lý focus
	 * @author bnduc - 15.11.2019
	 */
	focusFirstControl(scope) {
		if (scope) {
			const me = this;

			let input;
			if (
				scope.type === 'text' ||
				(scope.hasAttribute &&
					scope.hasAttribute('type') &&
					scope.getAttribute('type') === 'text')
			) {
				input = scope;
			} else {
				input = me.findFirstControlFocus(scope);
			}

			if (input) {
				input.focus();
			}
		}
	}

	/**
	 * Tìm ra control Input đầu tiên theo scope truyền vào và cho phép sửa
	 * @param {Element} scope Parent cần tìm input
	 * @author bnduc - 15.11.2019
	 */
	findFirstControlFocus(scope) {
		if (scope && scope.querySelector) {
			let input = scope.querySelector(
				'input:not([readonly]):not([disabled]),button:not([disable]),a,textarea'
			);
			return input;
		}
		return;
	}

	/**
	 * focus vào control trước đó
	 */
	focusPreviewControl(curfocus) {
		let fn = function(parent) {
			let items = parent.querySelectorAll(
				'input:not([disabled]),button:not([disable]),a'
			);
			if (items[0] !== curfocus) {
				for (let i = 1; i < items.length; i++) {
					if (items[i] === curfocus) {
						for (let j = i - 1; j >= 0; j--) {
							//check item visible
							if (items[j].offsetParent) {
								items[j].focus();
								return;
							}
						}
						//reset focus to parent
						curfocus = parent;
					}
				}
			}
			fn(parent.parentElement);
		};

		fn(curfocus.parentElement);
	}

	/**
	 * focus vào control tiếp theo
	 */
	focusNextControl(curfocus, parent) {
		let fn = function(parent) {
			if (!parent) {
				return;
			}

			let items = parent.querySelectorAll(
				'input:not([disabled]),textarea:not([disabled]),button:not([disable]),a'
			);

			if (items[items.length - 1] !== curfocus) {
				for (let i = 1; i < items.length; i++) {
					if (items[i] === curfocus) {
						for (let j = i + 1; j < items.length; j++) {
							//check item visible
							if (items[j].offsetParent) {
								items[j].focus();
								return true;
							}
						}
					}
				}
			}

			return fn(parent.parentElement);
		};

		return fn(curfocus.parentElement);
	}

	/**
	 * Xử lý hiển thị dialog
	 * @author DNThang - 30.10.2019
	 * DNThang - 06.05.2020: Trong trường hợp owner là popup thì sẽ append vào content để không bị chìm ở dưới
	 */
	prepareForDialog(component, owner, options) {
		const me = this;
		if (owner && component) {
			let frmType = Vue.extend(component),
				frm = new frmType(options);

			frm.$mount();

			if (owner.isMsPopup) {
				let contentElement = owner.$refs.popupx; //owner.$el.querySelector('.ms-popup-content.ms-popup');
				contentElement.appendChild(frm.$el);
			} else {
				if (owner instanceof Element) {
					owner.appendChild(frm.$el);
				} else {
					owner.$el.appendChild(frm.$el);
				}
			}

			return frm;
		}

		return;
	}
	freezeKey(e) {
		e.stopPropagation();
		e.preventDefault();
	}
	mask() {
		const appLoading = document.getElementById('loading-bg');
		const bgLoading = document.getElementById('loading-filler');
		document.addEventListener('keydown', this.freezeKey);
		if (appLoading) {
			appLoading.style.display = null;
		}
		if (bgLoading) {
			bgLoading.style.display = null;
		}
	}

	unmask() {
		const appLoading = document.getElementById('loading-bg');
		const bgLoading = document.getElementById('loading-filler');
		document.removeEventListener('keydown', this.freezeKey);
		if (appLoading) {
			appLoading.style.display = 'none';
		}
		if (bgLoading) {
			bgLoading.style.display = 'none';
		}
	}

	/**
	 * Xử lý khi focus control cuối cùng thì sẽ thực thi fn
	 */
	processUnfocusLastControl(e, fn) {
		if (e.which === 9 && !e.shiftKey) {
			let cur = e.target;
			let els = e.currentTarget.querySelectorAll('*');
			let flag = true;
			for (let i = 0; i < els.length; i++) {
				if (els[i] === cur) {
					flag = false;
					continue;
				}
				if (flag) {
					continue;
				}

				els[i].focus();
				if (els[i] === document.activeElement) {
					e.preventDefault();
					return;
				}
			}

			//focus first control
			e.preventDefault();
			fn();
		}
	}

	downloadLink(link) {
		// location.href = link;
		let a = document.getElementById('adownload');
		a.href = link;
		a.click();
	}

	previewLink(link) {
		// location.href = link;
		// let a = document.getElementById('adownload');
		// a.href = link;
		// a.click('xxx');
		window.open(link, '_blank');
	}

	/**
	 * Validate địa chỉ email
	 *
	 * Created by: pvduong1 - 24/11/2019
	 */
	validateEmail(email) {
		let re = /^(([^<>()\[\]\.,;:\s@\""]+(\.[^<>()\[\]\.,;:\s@\""]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return re.test(email.toLocaleLowerCase());
	}

	/**
	 * Cá chép thông tin từ from cho to
	 * @param {*} from
	 * @param {*} to
	 */
	extend(from, to) {
		for (let i in from) {
			to[i] = from[i];
		}
	}

	/**
	 * Lấy ra thông tin Người dùng đăng nhập vào hệ thống (đã được lưu trữ trog store)
	 * (Bê từ session sang đây)
	 * @author DNThang - 05.12.2019
	 */
	getUserInfo() {
		return store.state.auth.userInfo;
	}

	/**
	 * Clone dữ liệu của mảng
	 * Sẽ tạo ra 1 mảng mới với dữ liệu được clone từ từng phần tử của mảng truyền vào
	 */
	cloneArrayData(inputArray) {
		let result = [];

		if (inputArray) {
			inputArray.forEach(function(item) {
				let temp = {};
				Object.assign(temp, item);
				result.push(temp);
			});
		}

		return result;
	}

	/**
	 * Clone dữ liệu của mảng model
	 * Sẽ tạo ra 1 mảng mới với dữ liệu được clone từ từng phần tử của mảng truyền vào
	 */
	cloneArrayModelData(inputArray) {
		let result = [];

		if (inputArray) {
			inputArray.forEach(function(item) {
				let temp = {};
				Object.assign(temp, item.$data);
				result.push(temp);
			});
		}

		return result;
	}

	shortkeyPushView(el) {
		window.shortkeyView.remove(el);
		window.shortkeyView.push(el);
	}

	shortkeyPopView(el) {
		window.shortkeyView.remove(el);
	}

	/**
	 * Kiểm tra 2 đối tượng có phải là cha con của nhau không
	 */
	hasParent(child, parent) {
		if (child.parentElement) {
			if (child.parentElement === parent) {
				return true;
			} else {
				return this.hasParent(child.parentElement, parent);
			}
		}

		return false;
	}

	/**
	 * Lấy đối tượng cha theo style class
	 */
	getParentByClass(child, className) {
		if (!child.parentNode) {
			return null;
		}

		if (this.hasClass(child.parentNode, className)) {
			return child.parentNode;
		} else {
			return this.getParentByClass(child.parentNode, className);
		}
	}

	/**
	 * Kiểm tra đối tượng có class style không
	 */
	hasClass(element, className) {
		return element.className.indexOf(className) > -1;
	}

	/**
	 * Ẩn tất cả các toast thông báo auto ẩn mà chưa đủ thời gian hiển thị để ẩn đi
	 * dùng cho tình huống khi nhấn cất/ghi sổ/bỏ ghi -> ẩn hết các thông báo cũ đi để thực hiện tại
	 */
	hideAllToast() {
		let els = document.querySelectorAll('.ms-toastfications');

		if (els && els.length > 0) {
			for (let i = 0; i < els.length; i++) {
				els[i].style.display = 'none';
			}
		}
	}

	/**
	 * Quay lại màn hình trước đó
	 */
	goBack(component, defaultPath) {
		let last = null,
			path = component.$route.path.toLowerCase();
		do {
			last = _routerHistory.pop();
		} while (last && last === path);

		component.$router.push(last || defaultPath || '/');
	}

	/**
	 * Hàm thông báo lỗi (nếu có refs truyền vào thì sẽ apply message vào refs)
	 * @param {Object} frm this
	 * @param {String} message tên lỗi
	 * @param {String} {optional - Nếu có thì sẽ border đỏ và focus control} refs tên refs control bị lỗi validate
	 * @author NCThanh1 - 13.09.2019
	 */
	onError(frm, message, refsName) {
		if (refsName) {
			const ref = frm.$refs[refsName];
			ref.$refs.provider.applyResult({
				errors: [message],
				valid: false,
				failedRules: {}
			});
			ref.$el.querySelector('input').focus();
		} else {
			frm.$ms.msgBox.showError(message);
		}
		return false;
	}

	/**
	 * Hàm kiểm tra số nhập liệu quá lớn
	 *
	 * Created by: pvduong1 - 14/02/2020
	 */
	checkTooBigNumber(number, message) {
		let MAX_VALUE = 99999999999999.9999;

		if (number >= MAX_VALUE) {
			if (message) {
				this.$ms.msgBox.showError(message);
			}

			return false;
		}
		return true;
	}

	//Build vue key cho data
	genVKeyValue(data) {
		if (data) {
			data.forEach(item => {
				if (!item.__vKeyValue) {
					item.__vKeyValue = this.generateUUID();
				}
			});
		}
	}

	//Chuyển dữ liệu thành dạng tree
	// Created by LTDAT(16.06.2020)
	nomalizeDataTree(data, idField, parentField) {
		const me = this;
		let dataTemp = [...data],
			parentNodes = [];
		dataTemp.forEach((item, index) => {
			if (!item.hasOwnProperty('parentNode')) {
				item['parentNode'] = [];
			}
			if (item[parentField]) {
				//Tìm cha
				let parent = _.find(dataTemp, o => {
					return o[idField] === item[parentField];
				});
				if (parent) {
					item.parentNode = parent;
					if (!parent.hasOwnProperty('childNodes')) {
						parent['childNodes'] = [];
					}
					if (!parent.hasOwnProperty('isParent')) {
						parent['isParent'] = true;
					}
					parent.childNodes.push(item);
				}
			} else {
				parentNodes.push(item);
			}
		});
		return parentNodes;
	}

	/**
	 * Thực hiện ghép các node cha đi kèm với các node con luôn để thực hiện show ra ngay bên dưới node cha
	 * @param {[TreeModel]} dataResoures Danh sách các node cha cần sắp xếp
	 * @param {*} expanded Có Mở rộng ra không
	 * @param {*} level
	 */
	getBodyData(dataResoures, expanded, level = 1, childNodes = 'childNodes') {
		if (!dataResoures) {
			return [];
		}
		let data = [...dataResoures];
		let bodyData = [];
		data.forEach((row, index) => {
			const children = row[childNodes];
			const childrenLen =
				Object.prototype.toString.call(children).slice(8, -1) ===
				'Array'
					? children.length
					: 0;

			row.level = level;
			Vue.set(row, 'isHide', false);
			Vue.set(row, 'expanded', expanded);
			// row.expanded = expanded;
			row.isSelected = false;
			row._isSelectedMultiple = false;

			bodyData.push(row);
			if (childrenLen > 0) {
				row._expandable = true;
				bodyData = bodyData.concat(
					this.getBodyData(children, expanded, level + 1)
				);
			}
		});

		return bodyData;
	}

	getDataFromEnum(enumName, keyList) {
		let ret = [];
		let i18nEnum = i18n.t('i18nEnum');
		Object.keys(MSEnum[enumName]).forEach(key => {
			let item = null;
			if (keyList) {
				if (keyList.includes(MSEnum[enumName][key])) {
					item = {
						value: MSEnum[enumName][key],
						display: i18nEnum[enumName][key]
					};
					ret.push(item);
				}
			} else {
				item = {
					value: MSEnum[enumName][key],
					display: i18nEnum[enumName][key]
				};
				ret.push(item);
			}
		});
		return ret;
	}

	/**
	 * Hàm dùng để kiểm tra thay đổi giữa 2 dữ liệu
	 * @params newVal giá trị mới
	 * @params oldVal giá trị cũ
	 * @params ListCheckOut chứa các field bỏ qua không cần phải check
	 *  */
	checkChanges(newVal, oldVal, ListCheckOut) {
		let ret = false;
		if (typeof newVal == 'object' && typeof oldVal == 'object') {
			for (let field in newVal) {
				if (ListCheckOut && ListCheckOut.includes(field)) {
					continue;
				}
				if (newVal[field] != oldVal[field]) {
					ret = true;
					break;
				}
			}
		}
		return ret;
	}

	/**
	 * Lấy ra file popup component
	 */
	getPopupInstance(popupItems, instance, propsData = {}) {
		const me = this;
		let formPopup = {};
		formPopup[instance.name] = popupItems[instance.name];
		if (!formPopup[instance.name]) {
			let form = Vue.extend(instance);
			popupItems[instance.name] = new form({
				i18n,
				store,
				propsData: propsData
			});
			popupItems[instance.name].$mount();
		}
		return popupItems[instance.name];
	}
	async getPopupInstanceAsync(popupItems, instance, propsData = {}) {
		const me = this;
		if (typeof instance == 'function') {
			if (!popupItems[instance.name]) {
				instance = await instance();
				instance = instance.default;
			}
		}

		let formPopup = {};
		formPopup[instance.name] = popupItems[instance.name];
		if (!formPopup[instance.name]) {
			let form = Vue.extend(instance);
			popupItems[instance.name] = new form({
				router,
				i18n,
				store,
				propsData: propsData
			});
			popupItems[instance.name].$mount();
		}
		return popupItems[instance.name];
	}

	splitSecurityEmail(value) {
		let ret = '';
		ret =
			value.substr(0, 2) +
			'***' +
			value.substring(value.indexOf('@'), value.length);
		return ret;
	}

	splitSecurityPhone(value) {
		let ret = '*******';
		ret += value.substr(value.length - 3, value.length);
		return ret;
	}

	changeAlias(str) {
		if (str) {
			str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
			str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
			str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
			str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
			str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
			str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
			str = str.replace(/đ/g, 'd');
			str = str.replace(/Đ/g, 'D');
			str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
			str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
			str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
			str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
			str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
			str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
		}
		return str;
	}

	// tìm ra vị trí ký tùy từng file xml
	findSignLocation(submissionType) {
		const me = this;
		let result = MSEnum.SignLocation.Pay_RegistrationServiceTVAN_Sign;
		switch (submissionType) {
			case MSEnum.SubmissionType.Pay_RegistrationServiceTVAN:
			case MSEnum.SubmissionType.Pay_ChangeBankService:
				result = MSEnum.SignLocation.Pay_RegistrationServiceTVAN_Sign;
				break;
			case MSEnum.SubmissionType.Pay_StopServiceTVAN:
				result = MSEnum.SignLocation.Pay_StopServiceTVAN_Sign;
				break;
			case MSEnum.SubmissionType.Pay_ChangeInfoService:
				result = MSEnum.SignLocation.Pay_ChangeInfoService_Sign;
				break;
			case MSEnum.SubmissionType.Pay_StopBank:
				result = MSEnum.SignLocation.Pay_StopBank_Sign;
				break;
		}
		return result;
	}

	// tìm ra vị trí ký tùy từng file xml của ký esgin
	findSignLocationRemoteSigning(submissionType) {
		const me = this;
		let result = MSEnum.SignLocation.Pay_RegistrationServiceTVAN_Sign;
		switch (submissionType) {
			case MSEnum.SubmissionType.Pay_RegistrationServiceTVAN:
			case MSEnum.SubmissionType.Pay_ChangeBankService:
				result =
					MSEnum.SignLocation.Rm_Pay_RegistrationServiceTVAN_Sign;
				break;
			case MSEnum.SubmissionType.Pay_StopServiceTVAN:
				result = MSEnum.SignLocation.Rm_Pay_StopServiceTVAN_Sign;
				break;
			case MSEnum.SubmissionType.Pay_ChangeInfoService:
				result = MSEnum.SignLocation.Rm_Pay_ChangeInfoService_Sign;
				break;
			case MSEnum.SubmissionType.Pay_StopBank:
				result = MSEnum.SignLocation.Rm_Pay_StopBank_Sign;
				break;
		}
		return result;
	}

	// tìm ra vị trí ký tùy từng file xml vùng chữ ký để ký
	findSignLocationRemoteSigningHasSign(submissionType) {
		const me = this;
		let result = MSEnum.SignLocation.Pay_RegistrationServiceTVAN_Sign;
		switch (submissionType) {
			case MSEnum.SubmissionType.Pay_RegistrationServiceTVAN:
			case MSEnum.SubmissionType.Pay_ChangeBankService:
				result =
					MSEnum.SignLocation.RmHs_Pay_RegistrationServiceTVAN_Sign;
				break;
			case MSEnum.SubmissionType.Pay_StopServiceTVAN:
				result = MSEnum.SignLocation.RmHs_Pay_StopServiceTVAN_Sign;
				break;
			case MSEnum.SubmissionType.Pay_ChangeInfoService:
				result = MSEnum.SignLocation.RmHs_Pay_ChangeInfoService_Sign;
				break;
			case MSEnum.SubmissionType.Pay_StopBank:
				result = MSEnum.SignLocation.RmHs_Pay_StopBank_Sign;
				break;
		}
		return result;
	}

	filterListObjByKey(data, field, value) {
		let ret = [];
		if (data && data.length > 0) {
			data.forEach(item => {
				if (
					item[field] &&
					item[field].toString() &&
					item[field]
						.toString()
						.toLowerCase()
						.contains(value.toLowerCase())
				) {
					ret.push(item);
				}
			});
		}
		return ret;
	}
	filterObjByKey(data, field, value) {
		if (
			data[field] &&
			data[field].toString() &&
			data[field]
				.toString()
				.toLowerCase()
				.contains(value.toLowerCase())
		) {
			return data;
		}
		return null;
	}

	PercentDate(from, to, now) {
		let timeRanger = new Date(to).getTime() - new Date(from).getTime();
		let timeFromToNow = new Date(now).getTime() - new Date(from).getTime();
		return (timeFromToNow / timeRanger) * 100;
	}
	getDictrictName(District) {
		if (District) {
			return District.replace('Quận', '')
				.replace('Huyện', '')
				.replace('Thành phố', '')
				.replace('Thị xã')
				.trim();
		}
		return null;
	}
	//Tìm kiếm item trong list
	//Created by LTDAT(16.06.2020)
	filterItemByText(queryText, data) {
		const me = this;
		let value = queryText,
			retItem = null;
		if (data) {
			retItem = data.find((item, _index) => {
				let ret = false;
				for (let key in item) {
					ret =
						item[key] &&
						item[key].toString() &&
						item[key]
							.toString()
							.toLowerCase()
							.contains(value.toLowerCase());
					if (ret) {
						return ret;
					}
				}
				if (ret) {
					return ret;
				}
			});
		}
		return retItem;
	}

	cloneDeepData(data) {
		let dataDeepClone = _.cloneDeep(data);
		return dataDeepClone;
	}
	
	downloadByBlob(fileContent, ContentType, name) {
		//Kiểm tra xem có dữ liệu không thì mới tải
		if (!fileContent) return;

		//Không có dữ liểu tải về
		if (fileContent.byteLength == 0) {
			let isDownloadFile =
				ContentType.includes('zip') ||
				ContentType.includes('xml') ||
				ContentType.includes('pdf');
			return;
		}

		//Tải tệp tin
		let blob = new Blob([fileContent], { type: ContentType });
		let url = URL.createObjectURL(blob);
		const downloadLink = document.createElement('a');
		const fileName = name;
		downloadLink.href = url;
		downloadLink.download = fileName;
		downloadLink.click();
		setTimeout(() => {
			URL.revokeObjectURL(url);
		});
	}

	/**
	 * Theo dõi chiều cao 1 element bằng ResizeObserver rồi ghi vào CSS variable trên :root
	 * để layout (sidebar, navbar, router-view...) tính lại top/height theo banner/notification.
	 * Gọi lại cùng cssVarName → disconnect observer cũ (tránh leak).
	 * Height lấy từ borderBoxSize[0].blockSize, fallback contentRect.height.
	 * @param {HTMLElement} element Element cần đo
	 * @param {string} cssVarName Tên CSS variable, vd '--banner-height'
	 * @returns {ResizeObserver|null} null nếu element rỗng hoặc ResizeObserver không có
	 */
	observeElementHeight(element, cssVarName) {
		const me = this;
		if (!element || typeof ResizeObserver === 'undefined') return null;

		me._heightResizeObservers = me._heightResizeObservers || {};

		//Disconnect observer cũ của cùng cssVarName trước khi tạo mới — tránh leak
		if (me._heightResizeObservers[cssVarName]) {
			me._heightResizeObservers[cssVarName].disconnect();
		}

		//Reset về 0 trước khi có chiều cao thực tế
		document.documentElement.style.setProperty(cssVarName, '0px');

		me._heightResizeObservers[cssVarName] = new ResizeObserver((entries) => {
			for (const entry of entries) {
				const height =
					entry.borderBoxSize && entry.borderBoxSize[0]
						? entry.borderBoxSize[0].blockSize
						: entry.contentRect.height;
				document.documentElement.style.setProperty(
					cssVarName,
					height + 'px'
				);
			}
		});
		me._heightResizeObservers[cssVarName].observe(element);
		return me._heightResizeObservers[cssVarName];
	}

	/**
	 * Hủy observer của 1 CSS variable và xóa variable khỏi :root
	 * @param {string} cssVarName
	 */
	disposeElementHeightObserver(cssVarName) {
		const me = this;
		if (me._heightResizeObservers && me._heightResizeObservers[cssVarName]) {
			me._heightResizeObservers[cssVarName].disconnect();
			delete me._heightResizeObservers[cssVarName];
		}
		document.documentElement.style.removeProperty(cssVarName);
	}
}

export default new CommonFunction();
